import {format} from 'date-fns';
import {UTCDateTimeString} from '../../../data/timeslots/apiTypes';
import {getSortedConnectedUsersWithReservationOnDateInNode} from '../../../data/timeslots/selectors';
import {useAppSelector} from '../../../hooks';
import {FeatureToggle, getConnectedUsersByDate} from '../../../data';

// Make to be used as a drop in replacement for useAppSelector(getConnectedUsersByDate...);
// Warning: does not trigger a data load!
export const useConnectionsInNodeOnDate = (selectorProps: {nodeId: string; date: UTCDateTimeString}) => {
  return useAppSelector((state) => {
    if (state.data.features.enabledFeatures.includes(FeatureToggle.TimeslotsApi)) {
      return getSortedConnectedUsersWithReservationOnDateInNode(state, {
        dateKey: format(new Date(), 'yyyy-MM-dd'),
        nodeId: selectorProps.nodeId,
      });
    }

    return getConnectedUsersByDate(state, selectorProps);
  });
};
